"use client";

import Footer from "@/components/layout/footer";
import { Toaster } from "@/components/ui/toaster";

export default function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <Toaster />
      <Footer />
    </>
  );
} 
